unit View.Crud.Container;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, WEBLib.Controls, Vcl.Forms,
  WEBLib.ExtCtrls, Vcl.StdCtrls, WEBLib.StdCtrls,

  App.Types, UHelperServer, JS, UUtils, Web;

type
  TShowCrudListProc = reference to function(const AElementId: string;
    AEditProc: TEditProc): TForm;
  TShowCrudEditProc = reference to function(const AElementId: string;
    AListProc: TListProc; AId: JSValue): TForm;

  TFViewCrudContainer = class(TForm)
    WebPanel1: TPanel;
    lbTitle: TLabel;
    btnSalvarPersonalizacaoTabela: TButton;
    btnRestaurarPersonalizacao: TButton;
    [async]
    procedure btnSalvarPersonalizacaoTabelaClick(Sender: TObject); async;
    [async]
    procedure btnRestaurarPersonalizacaoClick(Sender: TObject); async;
  private
    FChildForm: TForm;
    FShowCrudListProc: TShowCrudListProc;
    FShowCrudEditProc: TShowCrudEditProc;
    FRoute: string;
    FRouteQueryString: string;
    FRestoringHash: Boolean;
    FInitialEditId: JSValue;
    function BuildHash(AEditId: JSValue): string;
    procedure ApplyRouteFilters;
    procedure UpdateHash(AEditId: JSValue);
    procedure ShowListForm;
    procedure ShowEditForm(AId: JSValue);
  public
    class function CreateForm(AElementID: string;
      ATitle: string; AShowCrudListProc: TShowCrudListProc;
      AShowCrudEditProc: TShowCrudEditProc; ARoute: string = '';
      ARouteQueryString: string = ''; ARestoringHash: Boolean = False;
      AInitialEditId: JSValue = nil): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCrudContainer: TFViewCrudContainer;

implementation


{$R *.dfm}

procedure TFViewCrudContainer.btnRestaurarPersonalizacaoClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
    'restaurar a personalização para o padrão?')) then
  begin
    TUtils.FInstanciaPersonalizacaoTabela.RestaurarPersonalizacao;
  end;
end;

procedure TFViewCrudContainer.btnSalvarPersonalizacaoTabelaClick(
  Sender: TObject);
var
  lJsonStr: string;
  lTotalMarcados: Integer;
begin
  asm
    lTotalMarcados = $('#columnsList .column-item input[type="checkbox"]:checked').length;
  end;

  if lTotalMarcados < 2 then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Selecione pelo menos 2 colunas ' +
    'para ficarem visíveis!');

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
    'salvar essa personalização?')) then
  begin
    asm
      // monta array de colunas
      var colunas = [];

      $('#columnsList .column-item').each(function (index) {
        colunas.push({
          indice: index,
          nome: this.id,
          titulo: $(this).find('.column-label').text().trim(),
          visivel: $(this).find('input[type="checkbox"]').is(':checked')
        });
      });

      // pega o radio selecionado (pageSize)
      var tamanhoPagina = $('input[name="pageSize"]:checked').val();

      // objeto final
      var obj = {
        tamanho_pagina: parseInt(tamanhoPagina, 10),
        colunas: colunas
      };

      lJsonStr = JSON.stringify(obj);
    end;

    TUtils.FInstanciaPersonalizacaoTabela.SalvarPersonalizacao(lJsonStr);
  end;
end;

function TFViewCrudContainer.BuildHash(AEditId: JSValue): string;
var
  lId: string;
begin
  Result := '';

  if FRoute = '' then
    Exit;

  Result := '#/' + FRoute;

  if not IsNull(AEditId) then
  begin
    asm
      lId = encodeURIComponent(String(AEditId));
    end;
    Result := Result + '/editar/' + lId;
  end;

  if FRouteQueryString <> '' then
    Result := Result + '?' + FRouteQueryString;
end;

procedure TFViewCrudContainer.ApplyRouteFilters;
var
  lQueryString: string;
begin
  // O botao voltar interno nao dispara hashchange. Reaplicamos aqui os filtros
  // serializados na rota antes de recriar a listagem.
  lQueryString := FRouteQueryString;
  asm
    var params = new URLSearchParams(lQueryString || '');
    pas.UHelperServer.THelperServer.FQuery = params.get('query') || params.get('filter') || '';
    pas.UHelperServer.THelperServer.FQueryProdutos = params.get('queryProdutos') || '';
    pas.UHelperServer.THelperServer.FFilterParametro = params.get('filterParametro') || '';
  end;
end;

class function TFViewCrudContainer.CreateForm(AElementID, ATitle: string;
  AShowCrudListProc: TShowCrudListProc; AShowCrudEditProc: TShowCrudEditProc;
  ARoute, ARouteQueryString: string; ARestoringHash: Boolean;
  AInitialEditId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  var
    lForm: TFViewCrudContainer;
  begin
    lForm := TFViewCrudContainer(AForm);
    lForm.lbTitle.Caption := ATitle.Replace('_', ' ');
    lForm.FShowCrudListProc := AShowCrudListProc;
    lForm.FShowCrudEditProc := AShowCrudEditProc;
    lForm.FRoute := ARoute;
    lForm.FRouteQueryString := ARouteQueryString;
    lForm.FRestoringHash := ARestoringHash;
    lForm.FInitialEditId := AInitialEditId;

    lForm.ShowListForm;

    if not IsNull(AInitialEditId) then
    begin
      asm
        setTimeout(function () {
          lForm.ShowEditForm(AInitialEditId);
        }, 0);
      end;
    end
    else
      lForm.FRestoringHash := False;
  end;

begin
  Application.CreateForm(TFViewCrudContainer, AElementID, Result, @AfterCreate);
end;

procedure TFViewCrudContainer.ShowEditForm(AId: JSValue);
begin
  if IsNull(AId) then
    THelperServer.AtualizarTituloPagina(TTipoPagina.CADASTRO, lbTitle.Caption)
  else
    THelperServer.AtualizarTituloPagina(TTipoPagina.EDICAO, lbTitle.Caption);

  if Assigned(FChildForm) then
    FChildForm.Free;

  UpdateHash(AId);
  FChildForm := FShowCrudEditProc(WebPanel1.ElementID, @ShowListForm, AId);
end;

procedure TFViewCrudContainer.ShowListForm;
begin
  THelperServer.AtualizarTituloPagina(TTipoPagina.LISTAGEM, lbTitle.Caption);
  if Assigned(FChildForm) then
    FChildForm.Free;

  ApplyRouteFilters;
  UpdateHash(nil);
  FChildForm := FShowCrudListProc(WebPanel1.ElementID, @ShowEditForm);
end;

procedure TFViewCrudContainer.UpdateHash(AEditId: JSValue);
var
  lHash: string;
begin
  if FRestoringHash then
  begin
    FRestoringHash := False;
    Exit;
  end;

  lHash := BuildHash(AEditId);

  if (lHash <> '') and (window.location.hash <> lHash) then
  begin
    asm
      window.__facilRouterInternalHash = true;
    end;
    window.location.hash := lHash;
  end;
end;
procedure TFViewCrudContainer.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbTitle := TLabel.Create('view.crudcontainer.title');
  WebPanel1 := TPanel.Create('view.crudcontainer.webpanel');
  btnSalvarPersonalizacaoTabela := TButton.Create('btnSalvarPersonalizacaoTabela');
  btnRestaurarPersonalizacao := TButton.Create('btnRestaurarPersonalizacao');

  lbTitle.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnSalvarPersonalizacaoTabela.BeforeLoadDFMValues;
  btnRestaurarPersonalizacao.BeforeLoadDFMValues;
  try
    Name := 'FViewCrudContainer';
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbTitle.SetParentComponent(Self);
    lbTitle.Name := 'lbTitle';
    lbTitle.Left := 32;
    lbTitle.Top := 16;
    lbTitle.Width := 20;
    lbTitle.Height := 13;
    lbTitle.Caption := 'Title';
    lbTitle.HeightPercent := 100.000000000000000000;
    lbTitle.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 24;
    WebPanel1.Top := 43;
    WebPanel1.Width := 521;
    WebPanel1.Height := 289;
    WebPanel1.TabOrder := 0;
    btnSalvarPersonalizacaoTabela.SetParentComponent(Self);
    btnSalvarPersonalizacaoTabela.Name := 'btnSalvarPersonalizacaoTabela';
    btnSalvarPersonalizacaoTabela.Left := 184;
    btnSalvarPersonalizacaoTabela.Top := 392;
    btnSalvarPersonalizacaoTabela.Width := 96;
    btnSalvarPersonalizacaoTabela.Height := 25;
    btnSalvarPersonalizacaoTabela.Caption := 'Salvar';
    btnSalvarPersonalizacaoTabela.ChildOrder := 2;
    btnSalvarPersonalizacaoTabela.HeightPercent := 100.000000000000000000;
    btnSalvarPersonalizacaoTabela.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarPersonalizacaoTabela, Self, 'OnClick', 'btnSalvarPersonalizacaoTabelaClick');
    btnRestaurarPersonalizacao.SetParentComponent(Self);
    btnRestaurarPersonalizacao.Name := 'btnRestaurarPersonalizacao';
    btnRestaurarPersonalizacao.Left := 286;
    btnRestaurarPersonalizacao.Top := 392;
    btnRestaurarPersonalizacao.Width := 96;
    btnRestaurarPersonalizacao.Height := 25;
    btnRestaurarPersonalizacao.Caption := 'Restaurar';
    btnRestaurarPersonalizacao.ChildOrder := 2;
    btnRestaurarPersonalizacao.HeightPercent := 100.000000000000000000;
    btnRestaurarPersonalizacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnRestaurarPersonalizacao, Self, 'OnClick', 'btnRestaurarPersonalizacaoClick');
  finally
    lbTitle.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnSalvarPersonalizacaoTabela.AfterLoadDFMValues;
    btnRestaurarPersonalizacao.AfterLoadDFMValues;
  end;
end;

end.
